import { Injectable } from "@angular/core";
import { OwlDateTimeIntl } from "@danielmoncada/angular-datetime-picker"

@Injectable()
export class DefaultIntl extends OwlDateTimeIntl {

    /** A label for the set button */
    override setBtnLabel: string = 'Ok';

    /** A label for the cancel button */
    override cancelBtnLabel: string = 'Annulla';

    /** A label for the range 'from' in picker info */
    override rangeFromLabel: string = 'Dal';

    /** A label for the range 'to' in picker info */
    override rangeToLabel: string = 'Al';
};